import { Link } from "react-router";

export default function NotFound() {
  return (
    <section className="space-y-4">
      <h1 className="text-xl font-semibold">Not found</h1>
      <p className="text-sm text-neutral-400">
        No route matches this URL. Firebase Hosting serves index.html for any path it does not
        recognise, so a deep link to a deleted page lands here rather than on a 404 from the CDN.
      </p>
      <Link to="/" className="text-sm text-neutral-300 underline hover:text-white">
        Home
      </Link>
    </section>
  );
}
